{
  "app_name": "Moonwake",
  "extend_asleep": "Уснул",
  "extend_button": "Продлить сон",
  "extend_tip": "Попытка началась в {0}. Удалось — нажмите «Уснул», эти минуты останутся сном. Не удалось — «Проснулся»: бодрствование пойдёт с {0}.",
  "extend_title": "Продлеваем сон",
  "nap_before_hint": "Сколько спать после предыдущего окна — таймер подскажет во время сна.",
  "nap_before_label": "Сон перед этим ВБ",
  "nap_hint": "По графику — {0}, то есть до {1}.",
  "nap_less": "Меньше на пять минут",
  "nap_more": "Больше на пять минут",
  "nap_not_set": "не задан",
  "ring_extending": "продлеваем",
  "ring_left": "осталось",
  "ring_time_up": "20 минут прошли",
  "ring_total_awake": "всего {0}",
  "schedule_add": "+ ВБ",
  "schedule_by_age": "по возрасту",
  "schedule_fallback_hint": "Дальше «{0}» график не расписан: окна пойдут по возрасту, {1}–{2} мин.",
  "schedule_first": "ВБ 1",
  "schedule_pick": "Какое ВБ сейчас идёт",
  "schedule_name_label": "Название",
  "schedule_remove": "Убрать это ВБ",
  "schedule_remove_q": "Убрать {0}?",
  "schedule_remove_text": "Фазы этой карточки пропадут. Прошедшие окна не изменятся.",
  "schedule_rename": "Переименовать ВБ",
  "schedule_switch_label": "Окна бодрствования",
  "site_art_sleep_hint": "по графику — до 10:55",
  "site_art_sleep_label": "Экран сна: отсчёт, подсказка по графику и кнопка «Продлить сон»",
  "site_feature_sleep_text": "После «уснул» кольцо считает сон и подсказывает, сколько спать по графику. Заворочался — «Продлить сон»: двадцать минут на попытку, и приложение само разберётся, был это сон или уже бодрствование. День потом читается как переписка: сон слева, бодрствование справа, с комментариями; сверху — средние за три дня с подсветкой нормы по возрасту, а всё вместе выгружается в Excel для врача.",
  "site_feature_sleep_title": "Сон под присмотром",
  "site_meta_title": "Moonwake — ключ к хорошему сну вашего малыша",
  "site_meta_description": "Таймер бодрствования для малышей 0–18 месяцев: ведёт по фазам между снами, подсказывает, когда укладывать, и напоминает о смене фазы на телефоне и часах.",
  "site_nav_how": "Как работает",
  "site_nav_watch": "Часы",
  "site_nav_myday": "Окна дня",
  "site_nav_faq": "Вопросы",
  "site_cta_start": "Начать бесплатно",
  "site_cta_sign_in": "Войти",
  "site_cta_create_account": "Создать аккаунт",
  "site_cta_how": "Как это работает",
  "site_eyebrow": "Moonwake · для родителей малышей 0–18 мес",
  "site_hero_title": "Ключ к хорошему сну — *бодрствование*",
  "site_hero_text": "Таймер, который ведёт вас по фазам между снами: покормили, поиграли, успокоили — мягко подскажем, когда пора засыпать. Всё по возрасту вашего малыша, прямо на запястье.",
  "site_stores": "Android · Wear OS · браузер на любом телефоне",
  "site_phone_title": "Расписание для Паши",
  "site_phone_sub": "10 недель · 2–3 месяца · ~62 мин",
  "site_phone_tip": "На руках у окна, погремушка, поговорить. Зевнул — дальше",
  "site_phone_next": "Дальше: Столбиком, спокойно",
  "site_demo_phase": "Лёгкая игра",
  "site_demo_until": "до сна 32 мин",
  "site_float_phase_title": "Смена фазы",
  "site_float_phase_text": "Кормление, потом игра",
  "site_float_watch_title": "Часы",
  "site_float_watch_text": "Вибрация на запястье",
  "site_float_final_title": "Финал",
  "site_float_final_text": "Доброго сна ✨",
  "site_how_title": "Что делать, пока он не спит?",
  "site_how_lead": "Про сон написаны сотни приложений. Moonwake — про то, что между снами: порядок, время и спокойствие, что вы всё успеваете.",
  "site_feature_ring_title": "Нажали «Проснулся» — таймер запустился",
  "site_feature_ring_text": "Кольцо фаз рассчитано по времени и движется по часовой стрелке. На каждой смене — сигнал. Забыли включить вовремя? Нажмите фазу, где вы сейчас, или кнопку «Дальше» под кольцом — и отсчёт бодрствования пойдёт от настоящего момента.",
  "site_feature_watch_title": "Взгляд на запястье — и всё понятно",
  "site_feature_watch_text": "Телефон на бодрствовании редко в руках. Приложение работает и на умных часах: та же фаза, минуты и вибрация на переходе. Максимальное удобство, чтобы не отвлекаться в процессе.",
  "site_feature_myday_title": "Ваш день — ваши правила",
  "site_feature_myday_text": "Мы даём расписание по возрасту, но каждый малыш индивидуален. Меняйте порядок и длительность фаз, добавляйте прогулку или купание. Окон может быть несколько — как у сомнолога: ВБ 1 после подъёма, ВБ 2 после первого сна, у каждого своя длительность и свой сон перед ним. Подсказки к фазам — своими словами, а если день пошёл не по плану, какое ВБ идёт, выбирается кнопками прямо в таймере.",
  "site_feature_age_title": "Растёт вместе с малышом",
  "site_feature_age_text": "Введите дату рождения один раз. В первый месяц бодрствование длится 45 минут, к полутора годам — до пяти часов: окно и фазы меняются сами, когда ребёнок переходит в новый возраст. В разделе «Статьи» — короткие тексты под его возраст, а в календаре — аналитика и ваши заметки.",
  "site_about_title": "Сделано мамой, которая теряла время между снами",
  "site_about_text": "«Покормила — а дальше что? Залипла на гигиене и не успела поиграть. Каждый раз терялась». Moonwake — ориентир во избежание перегулов во время бодрствования ребёнка. Мы желаем, чтобы это приложение было полезным и стало вашим помощником на пути материнства.",
  "site_stat_programs": "программ по возрастам от рождения до полутора лет",
  "site_stat_button": "кнопка, чтобы начать. Всё остальное таймер делает сам",
  "site_stat_ads": "рекламы. Приложение для сна не должно отвлекать от важного",
  "site_final_title": "Доброго сна",
  "site_final_text": "Всё абсолютно бесплатно: таймер, расписание дня, календарь.",
  "site_modal_register": "Расскажите о малыше",
  "site_modal_sign_in": "С возвращением",
  "site_modal_check_mail": "Проверьте почту",
  "site_tabbar_label": "Разделы",
  "site_tab_home": "Главная",
  "site_tab_about": "О приложении",
  "site_footer_contacts": "Контакты",
  "site_footer_reply": "Отвечаем в течение дня",
  "site_footer_product": "Продукт",
  "site_footer_docs": "Документы",
  "site_footer_privacy": "Политика конфиденциальности",
  "site_footer_terms": "Условия использования",
  "site_footer_copyright": "© 2026 Moonwake",
  "site_footer_disclaimer": "Не медицинская рекомендация. При сомнениях — педиатр.",
  "site_art_ring_label": "Кольцо фаз бодрствования: фаза 3 из 5, до конца фазы 14:20",
  "site_art_ring_phase": "ФАЗА 3 ИЗ 5",
  "site_art_ring_left": "осталось в фазе",
  "site_art_watch_label": "Циферблат часов: фаза 3 из 5, лёгкая игра, 5:40",
  "site_art_watch_next": "дальше: спокойно",
  "site_art_myday_label": "Список фаз дня, который можно менять",
  "site_art_myday_rows": [
    "Подгузник + массаж",
    "Кормление",
    "Лёгкая игра",
    "Столбиком, спокойно"
  ],
  "site_art_myday_add": "+ прогулка, купание, массаж…",
  "site_art_growth_label": "Столбики: окно бодрствования растёт с возрастом",
  "site_art_growth_title": "Окно бодрствования по месяцам",
  "nav_timer": "Таймер",
  "nav_my_day": "Бодрствование",
  "nav_articles": "Статьи",
  "nav_calendar": "Календарь",
  "ok": "Готово",
  "cancel": "Отмена",
  "close": "Закрыть",
  "add": "Добавить",
  "save": "Сохранить",
  "delete": "Удалить",
  "minutes_short": "{0} мин",
  "min_unit": "мин",
  "onboarding_intro": "Расскажите о малыше — и мы подберём расписание бодрствования под его возраст.",
  "onboarding_name_label": "Как зовут малыша",
  "gender_boy": "Мальчик",
  "gender_girl": "Девочка",
  "born_boy": "Родился {0}",
  "born_girl": "Родилась {0}",
  "birth_date": "Дата рождения",
  "birth_date_pick": "Выбор даты рождения",
  "birth_date_none": "Дата не выбрана",
  "birth_date_choose": "Выберите дату",
  "month_word": "Месяц",
  "timer_subtitle_schedule": "{0} · окно {1}",
  "tour_text_5": "Сон слева, бодрствование справа, у каждой записи — время, место и ваши слова. Дни листаются стрелками, сверху — средние за три дня с огоньком «в норме ли для возраста», а весь период скачивается таблицей Excel.",
  "tour_text_6": "Первый смех, зубы, как спал — заметки по дням, а рядом сколько окон было и как прошёл день.",
  "tour_title_5": "День как переписка",
  "tour_title_6": "Календарь помнит важное",
  "year_word": "Год",
  "dp_today": "Сегодня",
  "dp_yesterday": "Вчера",
  "dp_week_ago": "Неделю назад",
  "default_child_name": "малыш",
  "now_age": "Сейчас: {0}",
  "schedule_named": "Расписание «{0}»",
  "window_summary": "Окно бодрствования {0}–{1} мин, {2} фаз",
  "gas_title": "Часто газики",
  "gas_subtitle": "Массаж в начало, столбик перед сном",
  "start": "Начать",
  "start_with": "Начать с {0}",
  "sync_trouble": "Записи с {0}, {1} пока не уходят на сервер — на телефоне они целы, приложение работает. Такие сбои видны нам в журнале, чиним.",
  "timer_title": "Бодрствование",

  "timer_title_sleep": "Сон",
  "timer_title_nap": "{0}-й за день",
  "timer_subtitle": "{0} · окно {1}–{2} мин",
  "started_at": " · начали в {0}",
  "ready": "Готовы?",
  "auto_closed": "Окно закрылось само в {0} — сон не отмечен. Когда проснётся — нажмите кнопку.",
  "night_hint": "Сейчас ночь: пробуждение запишем без фаз и уведомлений.",
  "night_wake_title": "Ночное пробуждение",
  "night_wake_tip": "С {0} · без фаз и уведомлений. Как уснёт — нажмите кнопку.",
  "night_asleep": "Уснул",
  "night_is_morning": "Это уже утро",
  "good_night": "Доброго сна",
  "good_night_tip": "Окно закрыто. Сладких снов {0} ✨ Когда проснётся — нажмите кнопку.",

  "sleep_timer": "Спит {0}",

  "sleep_timer_long": "Спит дольше 12 часов — отсчёт остановлен. Сон посчитаем до следующего «Проснулся».",
  "phase_n_of": "Фаза {0} из {1}",
  "in_this_phase": "{0} в этой фазе",
  "left_in_phase": "осталось в фазе",
  "over_plan": "дольше плана",
  "overtime_hint": "Дольше плана уже {0} мин. Как уснёт — нажмите «Уснул?»",
  "tired_prefix": "Устал? {0}",
  "next_label": "Дальше",
  "next_phase": "{0} · {1} мин",
  "to_sleep": "до сна {0} мин",
  "woke_up": "Проснулся",
  "fell_asleep": "Уснул?",
  "asleep_q": "Уснул?",
  "asleep_q_hint": "Окно бодрствования на этом закончится. Ответ мы запишем — он пригодится в отчётах.",
  "asleep_yes": "Да, уснул",
  "asleep_no": "Нет, ещё не спит",
  "next_arrow": "Дальше",
  "to_ritual_short": "К ритуалу",
  "reset_short": "Сброс",
  "tired_to_ritual": "Уже устал — к ритуалу",
  "reset_window": "Сбросить окно",
  "phase_list_hint": "Нажмите на фазу, где вы сейчас, — таймер посчитает окно так, будто предыдущие фазы уже прошли по расписанию.",
  "profile_edit": "{0} · {1} · изменить",
  "my_day_title": "Время бодрствования",
  "my_day_subtitle": "Окна дня по порядку: первое — после подъёма, следующее — после сна. Порядок и длительность фаз — ваши.",
  "program_named": "Программа «{0}»",
  "total_of_window": "{0} мин из {1}–{2}",
  "restore_recommended": "Вернуть рекомендованное",
  "window_too_long": "Окно длиннее рекомендованного — малыш может перегулять.",
  "window_too_short": "Окно короче рекомендованного — малышу может не хватить активности.",
  "phase_last_sub": "последняя фаза, двойная вибрация",
  "phase_flexible": "гибкая",
  "phase_fixed": "не сокращается",
  "phase_rename": "переименовать",
  "phase_locked": "эту фазу нельзя удалить",
  "remove_phase_title": "Удалить «{0}»?",
  "remove_phase_text": "Окно станет короче на {0} мин. Вернуть рекомендованное можно в любой момент.",
  "no_word": "Нет",
  "delete_word": "Удалить",
  "add_phase": "+ Добавить фазу: прогулка, купание, массаж…",
  "tired_signs": "Признаки усталости",
  "ritual_pinned": "Ритуал и сон всегда идут последними — их нельзя передвинуть или удалить.",
  "move_up": "Переместить выше",
  "move_down": "Переместить ниже",
  "delete_phase": "✕  Удалить фазу",
  "new_phase": "Новая фаза",
  "name_label": "Название",
  "type_label": "Тип",
  "duration": "Длительность",
  "custom_phase_tip": "Своя фаза",
  "phase_tip_title": "Подсказка: {0}",
  "phase_tip_edit_desc": "Изменить подсказку фазы «{0}»",
  "phase_tip_hint": "Её видно на таймере в этой фазе. Оставьте поле пустым — вернётся наша.",
  "phase_tip_restore": "Вернуть нашу подсказку",
  "phase_tip_empty": "Добавить подсказку",
  "minus_desc": "Меньше на минуту",
  "plus_desc": "Больше на минуту",
  "handle_desc": "Переместить или удалить фазу",
  "type_feed": "Кормление",
  "type_care": "Уход",
  "type_active": "Игра",
  "type_calm": "Спокойно",
  "preset_walk": "Прогулка",
  "preset_walk_tip": "Свежий воздух и новые звуки — коляска или слинг",
  "preset_bath": "Купание",
  "preset_bath_tip": "Тёплая вода 36–37°, без спешки",
  "preset_massage": "Массаж",
  "preset_massage_tip": "Лёгкие поглаживания, животик по часовой стрелке",
  "preset_feed": "Кормление",
  "preset_feed_tip": "Спокойно, без отвлечений",
  "preset_calm": "Спокойно",
  "preset_calm_tip": "Приглушить свет, тихий голос, на ручках",
  "articles_title": "Статьи",
  "articles_subtitle": "Подобраны под {0}. Коротко, без воды.",
  "chip_your_age": "Ваш возраст",
  "chip_sleep": "Сон",
  "chip_awake": "Бодрствование",
  "chip_night": "Ночь",
  "reading_now": "Читают сейчас",
  "hero_title": "Соска: как вынуть до засыпания и не разбудить",
  "hero_meta": "4 мин · 2–4 месяца",
  "article_1": "Что делать в бодрствование в 2 месяца",
  "article_1_meta": "5 мин",
  "article_2": "Признаки усталости, которые легко пропустить",
  "article_2_meta": "3 мин",
  "article_3": "Ночное кормление без «включения»",
  "article_3_meta": "4 мин",
  "article_4": "Похлопывания, шум, пеленание: что помогает",
  "article_4_meta": "6 мин",
  "article_5": "Регресс 4 месяцев: что впереди",
  "article_5_meta": "7 мин · скоро актуально",
  "articles_note": "Тексты статей появятся в следующих версиях.",
  "calendar_age": "Малышу {0}",
  "calendar_tab_month": "Календарь",
  "calendar_tab_weight": "Аналитика",
  "entry_new": "Новая запись",
  "entry_add": "Добавить запись",
  "entry_note": "Заметка",
  "entry_weight": "Вес",
  "day_sleep": "Сон за сутки",
  "day_windows": "Окна бодрствования",
  "day_night_wakes": "Ночные пробуждения",
  "day_weight": "Вес",
  "day_norm": "норма {0}",
  "day_usually": "обычно {0}",
  "day_approx": "примерно",
  "day_ahead": "Этот день ещё впереди",
  "day_ahead_hint": "Сводка появится, когда день настанет. А заметку можно записать заранее — например, приём у врача.",
  "no_notes_ahead": "Ничего не запланировано.",
  "day_approx_hint": "Отмечайте «Уснул?» в таймере — посчитаем точно",
  "rating_ok": "в норме",
  "rating_low": "ниже нормы",
  "rating_high": "выше нормы",
  "rating_none": "нет данных",
  "weight_record": "Записать вес",
  "weight_save": "Сохранить вес",
  "weight_first": "Первое взвешивание после рождения",
  "weight_delta_since": "{0} с {1} · было {2}",
  "weight_delta_per": "{0} за {1}",
  "weight_title": "Вес",
  "weight_subtitle_birth": "при рождении {0}",
  "weight_legend_who": "ВОЗ, 3–97 %",
  "weight_legend_mid": "середина",
  "weight_legend_low": "нижняя граница",
  "weight_now": "сейчас",
  "weight_chart_label": "График веса {0} в коридоре ВОЗ",
  "weight_state_ok": "Вес в норме",
  "weight_state_ok_text": "{0} крупнее примерно {1} % ровесников и растёт ровно, в своём коридоре.",
  "weight_state_low": "Ниже нормы",
  "weight_low_below": "{0} легче, чем {1} % ровесников его возраста. Это факт относительно нормы, а не диагноз.",
  "weight_low_slow": "Вес растёт медленнее, чем раньше: за последние недели малыш перешёл в коридор ниже. Это факт относительно нормы, а не диагноз.",
  "weight_low_drop": "В первые две недели вес снизился больше чем на десятую часть от веса при рождении.",
  "weight_gain_line": "{0} за {1} · минимум по возрасту {2}",
  "weight_state_high": "Выше нормы",
  "weight_state_high_text": "Последнее взвешивание выше коридора ВОЗ для возраста. Это факт относительно нормы, а не диагноз.",
  "weight_state_stale": "Давно не взвешивали",
  "weight_state_stale_text": "Последний раз — {0}, почти месяц назад. Взвесили у врача или дома? Запишите — обновим график.",
  "weight_state_empty": "Пока только вес при рождении",
  "weight_state_empty_text": "Внесите вес после взвешивания — покажем, как растёт.",
  "weight_state_none": "Взвешиваний пока нет",
  "weight_state_none_text": "Запишите вес — покажем его в коридоре ВОЗ для возраста.",
  "weighings": "Взвешивания",
  "weight_tap_hint": "Ошиблись на весах? Нажмите на запись — её можно удалить.",
  "weight_row_label": "Взвешивание {0}",
  "weight_delete_q": "Удалить взвешивание?",
  "calendar_year": "Год",
  "calendar_year_back": "К месяцам",
  "at_birth": "при рождении",
  "weight_preterm_note": "Ориентиры ВОЗ — для родившихся в срок.",
  "analytics_wake": "Сон и бодрствование",
  "analytics_weight": "Вес",

  "day_analytics_title": "Сон и бодрствование",


  "chat_day_total": "Итого: сон {0}",

  "chat_day_total_split": "дневной {0} · ночной {1}",
  "chat_day_total_wake": "бодрствование {0}",

  "chat_footnote": "Слева сон с луной, справа бодрствование с солнцем. «≈» — ответа «уснул» не было, время взято по плану. Жёлтая точка — есть комментарий. Нажмите на запись, чтобы поправить время или добавить комментарий.",
  "recent_title": "В среднем за 3 дня",
  "recent_range": "{0} – {1}",
  "recent_partial": "данные за {0} из 3 дней",
  "recent_sleep_total": "Ночной сон + дневной сон",
  "recent_sleep_night": "Ночной сон",
  "recent_wake": "Бодрствование",
  "recent_norm": "норма {0}",
  "recent_rating_ok": "в норме",
  "recent_rating_low": "меньше нормы",
  "recent_rating_high": "больше нормы",
  "recent_norm_note": "Зелёный — в норме для возраста, персиковый — меньше или больше. Сон за сутки — по нормам ВОЗ, ночь и дневной сон — по возрастным таблицам сна.",
  "recent_sleep_day": "Дневной сон",
  "recent_day_total": "Дневной сон + бодрствование",
  "recent_empty": "Средние появятся, когда наберётся хотя бы один полный день.",
  "day_prev": "Предыдущий день",
  "day_next": "Следующий день",
  "chat_day_empty": "За этот день записей нет.",

  "has_comment": "Есть комментарий",
  "comment_show": "Показать комментарий",
  "comment_hide": "Скрыть комментарий",

  "ring_sleeping": "спит",

  "ring_12h_plus": "12 ч+",

  "ring_stopped": "отсчёт остановлен",

  "export_opt_night_wake": "Ночное пробуждение",

  "export_legend": "Цвета",

  "analytics_sleep": "Сон",


  "export_button": "Скачать таблицу Excel",



  "export_what": "Что включить",



  "export_opt_sleep_total": "Сон (в общем)",



  "export_opt_night": "Ночной сон",



  "export_opt_day": "Дневной сон",



  "export_opt_wake": "Бодрствование",
  "export_opt_day_total": "Дневной сон + бодрствование",



  "export_from": "С",



  "export_to": "По",



  "export_bad_period": "Проверьте даты: начало не позже конца, и не в будущем",



  "export_title_sheet": "Сон и бодрствование",



  "export_made": "выгружено {0}",



  "export_stats": "Статистика",



  "export_total": "Итого за период",



  "export_days_with_data": "Дней с записями",



  "export_avg_sleep": "Сон в сутки, в среднем",



  "export_avg_nap": "Дневной сон, в среднем за сон",



  "export_naps_per_day": "Дневных снов в день",



  "export_avg_night": "Ночной сон, в среднем",



  "export_wakes_per_night": "Пробуждений за ночь",



  "export_avg_wake": "Бодрствование, среднее окно",
  "export_avg_day_total": "Дневной сон + бодрствование, в среднем",



  "export_norm": "норма {0}",



  "export_day_wake": "Бодрствование днём",



  "export_count_naps": "Дневных снов",



  "export_count_night_wakes": "Ночных пробуждений",



  "export_no_entries": "За выбранный период записей нет",


  "export_title": "Всё, что нужно, в одной таблице",




  "export_period": "Период",


  "export_period_week": "Неделя",


  "export_period_month": "Месяц",


  "export_period_all": "Всё время",


  "export_do": "Скачать",


  "export_privacy": "Файл собирается на вашем устройстве и остаётся у вас: на сервер он не уходит. В заголовке — имя и возраст малыша, как в таблицах для врача.",


  "export_downloaded": "Файл сохранён",


  "export_shared": "Файл передан",


  "export_failed": "Не получилось сохранить файл",


  "export_sheet_wake": "Бодрствование",


  "export_sheet_sleep": "Сон",


  "export_sheet_days": "По дням",


  "export_col_date": "Дата",


  "export_col_minutes": "Минуты",


  "export_col_mark": "Пометка",


  "export_col_norm": "Норма, мин",


  "export_col_rating": "Оценка",


  "export_col_place": "Где уснул",


  "export_col_note": "Комментарий",


  "export_col_night": "Ночь",


  "export_col_windows": "Окон",


  "export_col_windows_norm": "Норма окон",


  "export_col_sleep": "Сон, мин",


  "export_col_sleep_norm": "Норма сна, мин",


  "export_col_night_wakes": "Ночных пробуждений",


  "export_col_approx": "Примерно",


  "export_yes": "да",


  "export_no": "нет",







  "sleep_title": "Сон",

  "sleep_list_title": "Сон по дням",

  "sleep_night_mark": "ночь",

  "sleep_after_night_wake": "после пробуждения",

  "sleep_no_data": "нет данных",

  "sleep_state_ok": "Сон по возрасту",

  "sleep_state_ok_text": "За неделю в среднем {0} в сутки. Норма для «{1}» — {2}.",

  "sleep_state_low": "Сна меньше обычного",

  "sleep_state_low_text": "За неделю в среднем {0} в сутки, а норма для «{1}» — {2}. Это факт относительно нормы, а не диагноз.",

  "sleep_state_high": "Сна больше обычного",

  "sleep_state_high_text": "За неделю в среднем {0} в сутки, а норма для «{1}» — {2}. Это факт относительно нормы, а не диагноз.",

  "sleep_state_empty": "Пока нечего показать",

  "sleep_state_empty_text": "Сон считается между пробуждениями: нужен хотя бы один день с таймером или вписанными окнами.",

  "sleep_card_naps": "Дневной сон в среднем {0}, обычно {1}.",

  "sleep_card_night": "Ночью в среднем {0}, пробуждений за ночь — {1}.",

  "sleep_footnote": "Сон — от ответа «уснул» до следующего «Проснулся». «≈» — ответа не было, конец окна взят по плану; длиннее 30 часов — не сон, а забытое приложение.",

  "sleep_tap_edit": "Нажмите на сон, чтобы поправить время или отметить, где и как уснул.",

  "sleep_empty_list": "Снов за две недели нет.",

  "sleep_ongoing_hint": "Сон ещё идёт: конец запишется, когда нажмёте «Проснулся». Сейчас можно поправить, когда уснул, отметить место и написать пару слов.",

  "sleep_row_label": "Сон {0}, {1}",

  "sleep_place_label": "Где уснул",

  "sleep_note_label": "Комментарий",

  "sleep_note_hint": "Пара слов о том, как уснул. Без подробностей о других людях — это личные данные.",

  "window_edit_unanswered": "Ответа «уснул» не было: конец подставлен по плану. Сохраните — и он станет точным.",

  "place_arms": "на руках",

  "place_crib": "в кроватке",

  "place_stroller": "в коляске",

  "place_breast": "на груди",

  "place_cosleep": "рядом с мамой",

  "place_car": "в машине",
  "wake_title": "Бодрствование",
  "wake_legend_norm": "окно по возрасту",
  "wake_chart_label": "Длительность окон бодрствования {0} за две недели",
  "wake_axis_min": "мин",
  "wake_state_ok": "Окна по возрасту",
  "wake_state_ok_text": "За неделю окно в среднем {0}. Расписание «{1}» рассчитано на {2}.",
  "wake_state_low": "Окна короче обычного",
  "wake_state_low_text": "За неделю окно в среднем {0}, а расписание «{1}» рассчитано на {2}. Это факт относительно нормы, а не диагноз.",
  "wake_state_high": "Окна длиннее обычного",
  "wake_state_high_text": "За неделю окно в среднем {0}, а расписание «{1}» рассчитано на {2}. Это факт относительно нормы, а не диагноз.",
  "wake_state_empty": "Пока нечего показать",
  "wake_state_empty_text": "Сюда попадают окна, где на «Уснул?» ответили «да». Без ответа неизвестно, когда малыш уснул, — такие окна не считаем.",
  "wake_trend": "Неделей раньше — в среднем {0}.",
  "wake_unconfirmed_one": "Ещё {0} окно за неделю без ответа «Уснул?» — в среднее оно не идёт.",
  "wake_unconfirmed_few": "Ещё {0} окна за неделю без ответа «Уснул?» — в среднее они не идут.",
  "wake_unconfirmed_many": "Ещё {0} окон за неделю без ответа «Уснул?» — в среднее они не идут.",
  "wake_list_title": "Окна по дням",
  "wake_row_label": "Окно {0}, {1}",
  "wake_empty_list": "Подтверждённых окон за две недели нет.",
  "wake_footnote": "Длительность — от «Проснулся» до ответа «уснул». «≈» — таймер включили не сразу, начало посчитано по плану.",
  "window_awake": "не уснул",
  "window_reset": "сброшено",
  "window_unanswered": "без ответа",
  "window_running": "идёт сейчас",
  "birth_weight": "Вес при рождении",
  "optional": "необязательно",
  "grams_short": "г",
  "birth_weight_missing": "не указан",
  "last_weight": "Последний вес — {0} · {1}",
  "no_weighings": "Взвешиваний пока нет · записать",
  "day_mode": "Режим дня",
  "day_mode_value": "{0} – {1}",
  "day_mode_start": "Начало дня",
  "day_mode_bedtime": "Укладывание до",
  "day_mode_wake_push": "Напоминать, что пора вставать",
  "day_mode_wake_hint": "С четырёх месяцев, только если сон отмечен",
  "day_mode_hint": "Ночью — с укладывания до начала дня — уведомлений нет.",
  "calendar_add_note": "Заметка",
  "add_note_desc": "Добавить заметку",
  "prev_month": "Предыдущий месяц",
  "next_month": "Следующий месяц",
  "no_windows": "Окон бодрствования не было",
  "windows_one": "{0} окно бодрствования",
  "windows_few": "{0} окна бодрствования",
  "windows_many": "{0} окон бодрствования",
  "time_to_sleep_x": "«Пора спать» ×{0}",
  "woke_at": "Проснулся: {0}",
  "no_notes_today": "Заметок пока нет. Нажмите «+», чтобы записать первый смех, рекордную ночь, зубы или визит к врачу.",
  "no_notes_day": "В этот день заметок нет.",
  "delete_note_q": "Удалить заметку?",
  "note_title": "Заметка · {0}",
  "today_word": "сегодня",
  "what_happened": "Что случилось",
  "tag_first": "Первый раз",
  "tag_sleep": "Сон",
  "tag_teeth": "Зубы",
  "tag_doctor": "Врач",
  "notif_channel_name": "Смена фазы",
  "notif_channel_desc": "Сигналы о переходе между фазами бодрствования",
  "notif_asleep_q_text": "Ритуал по плану закончился. Ответьте в приложении — окно закроется по вашему ответу.",
  "edit": "Изменить",
  "note_edit_title": "Изменить заметку",
  "note_time": "Время",
  "weekdays_short": [
    "Пн",
    "Вт",
    "Ср",
    "Чт",
    "Пт",
    "Сб",
    "Вс"
  ],
  "welcome_title": "Ключ к хорошему сну — бодрствование",
  "welcome_subtitle": "Таймер, который ведёт по фазам: покормили, поиграли, успокоили — и подсказывает, когда пора спать. По возрасту вашего малыша.",
  "welcome_start": "Начать",
  "welcome_have_account": "У меня уже есть аккаунт",
  "welcome2_title": "Нажали «Проснулся» — таймер запустился",
  "welcome2_subtitle": "Кольцо фаз, как у тренировки: покормили, поиграли, успокоили. На каждой смене — сигнал. Всё по возрасту вашего малыша.",
  "welcome3_title": "Взгляд на запястье — и всё понятно",
  "welcome3_subtitle": "На часах та же фаза и минуты, вибрация на переходе. В конце окна — «Доброго сна», и часы молчат.",
  "welcome_skip": "Пропустить",
  "welcome_register": "Регистрация",
  "signup_title": "Регистрация",
  "signup_lead": "Введите почту — пришлём код. Пароль не нужен: данные хранятся в аккаунте и не потеряются при смене телефона.",
  "need_connection": "Нет связи. Проверьте интернет и попробуйте ещё раз",
  "kid_add_needs_connection": "Чтобы добавить малыша, нужна связь с интернетом",
  "welcome_slides": "Слайды приветствия",
  "welcome_slide_n": "Слайд {0}",
  "welcome_demo_phase": "Лёгкая игра",
  "welcome_demo_until": "до сна 32 мин",
  "register_title": "Расскажите о малыше",
  "register_subtitle": "По возрасту подберём расписание, а имя будет в подсказках.",
  "gender_label": "Пол",
  "step_of": "Шаг {0} из {1}",
  "continue_word": "Продолжить",
  "back": "Назад",
  "sign_in_soon": "Вход по почте: пришлём код, пароль придумывать не нужно",
  "notify_enable": "Включить уведомления о смене фазы",
  "notify_push": "Уведомления придут, даже если закрыть приложение",
  "notify_screen": "Уведомления приходят, пока экран включён",
  "notify_blocked": "Уведомления запрещены в настройках браузера",
  "notify_offline": "Сервер недоступен: расписание уйдёт, когда появится сеть",
  "notify_blocked_app": "Уведомления запрещены в настройках приложения",
  "notify_ios": "На iPhone уведомления работают только у приложения на домашнем экране",
  "notify_ios_how": "Как добавить",
  "install_ios_title": "Добавьте Moonwake на домашний экран",
  "install_ios_why": "На iPhone это единственный способ получать уведомления о смене фазы: у страницы в браузере их не бывает. Займёт полминуты.",
  "install_ios_step1": "Нажмите «Поделиться» внизу Safari — квадрат со стрелкой вверх",
  "install_ios_step2": "Пролистайте список и выберите «На экран «Домой»»",
  "install_ios_step3": "Нажмите «Добавить». Moonwake появится рядом с обычными приложениями",
  "install_ios_after": "Откройте Moonwake с домашнего экрана и разрешите уведомления — дальше всё как в обычном приложении.",
  "install_button": "Установить приложение",
  "install_any_title": "Установите Moonwake как приложение",
  "install_any_why": "Так таймер открывается с домашнего экрана и работает без браузера. Ставится из самого браузера, магазин не нужен.",
  "install_any_step1": "Откройте меню браузера — три точки или три полоски в углу",
  "install_any_step2": "Выберите «Установить приложение» или «Добавить на главный экран»",
  "install_any_after": "Если такого пункта нет, браузер пока не умеет устанавливать приложения. Сайт при этом работает полностью.",
  "install_mobile_button": "Скачать приложение",
  "nav_menu": "Меню",
  "menu_profile": "Профиль",
  "menu_contacts": "Контакты",
  "gender_boy_short": "мальчик",
  "gender_girl_short": "девочка",
  "kid_current_mark": "показываем",
  "kid_switch_title": "Малыши",
  "kid_added": "Добавили малыша — расскажите о нём",
  "kid_switched": "Теперь показываем {0}",
  "kid_unnamed": "Без имени",
  "kid_born": "род. {0}",
  "kid_no_profile": "анкета не заполнена",
  "kid_no_records": "записей нет",
  "kid_last_record": "последняя запись {0}",
  "kid_remove": "Убрать",
  "kid_remove_q": "Убрать эту запись?",
  "kid_remove_text": "В ней нет ни одного окна, ни заметки, ни взвешивания. Запись исчезнет с этого устройства и со счёта. Данные других малышей останутся на месте.",
  "kid_removed": "Запись убрали",
  "kid_remove_busy": "Эту запись не убрать: в ней есть окна или заметки. Убрать можно только пустую запись",
  "kid_add_q": "Добавить второго малыша?",
  "kid_add_yes": "Добавить",
  "kid_add_text": "Это отдельная анкета: свой таймер, календарь и вес. Записанное о том, кого показываем ({0}), останется на месте — между малышами можно переключаться.",
  "kid_merged": "Две одинаковые анкеты свели в одну — показываем {0}",
  "profile_add_child": "+ Добавить второго малыша",
  "profile_second_child_soon": "Скоро: второй малыш в одном аккаунте",
  "profile_schedule": "Расписание",
  "profile_gas_short": "при газиках",
  "profile_email": "Почта",
  "profile_plan": "Тариф",
  "profile_plan_free": "Бесплатный",
  "profile_how_it_works": "Как это работает",
  "profile_tour": "тур",
  "profile_contacts_help": "Контакты и помощь",
  "sign_out_title": "Выйти из аккаунта?",
  "sign_out_text": "Данные останутся в аккаунте и вернутся при следующем входе. С этого устройства они будут удалены.",
  "sign_out_offline": "Нет связи: последние записи ещё не уехали на сервер. Выйдите при сети — иначе они останутся только здесь и сотрутся.",
  "sign_out_anyway": "Всё равно выйти",
  "delete_title": "Удалить аккаунт?",
  "delete_text": "Удалим аккаунт, данные малыша на сервере и на всех устройствах. Это навсегда.",
  "delete_confirm_name": "Введите имя малыша, чтобы подтвердить",
  "delete_go": "Удалить навсегда",
  "email_change_title": "Новая почта",
  "email_change_text": "Пришлём код на новый адрес. Пока он не подтверждён, вход остаётся по старому.",
  "email_get_code": "Получить код",
  "email_sent_to": "Отправили код на {0}",
  "email_code_label": "Код из письма",
  "email_confirm": "Подтвердить",
  "email_changed": "Почта изменена",
  "session_lost": "Сессия истекла — войдите снова",
  "account_gone": "Аккаунт удалён. Данные с этого устройства убраны",
  "profile_sign_out": "Выйти из аккаунта",
  "profile_privacy": "Конфиденциальность",
  "profile_delete": "Удалить аккаунт",
  "profile_delete_subject": "Удалить аккаунт Moonwake",
  "contacts_lead": "Вопрос, идея или что-то сломалось — напишите, отвечаем в течение дня.",
  "contacts_topic": "Тема",
  "contacts_topic_timer": "Вопрос по таймеру",
  "contacts_topic_watch": "Часы",
  "contacts_topic_account": "Аккаунт и вход",
  "contacts_topic_idea": "Идея или пожелание",
  "contacts_message": "Сообщение",
  "contacts_placeholder": "Расскажите, что случилось…",
  "contacts_send": "Отправить",
  "contacts_privacy": "Политика конфиденциальности",
  "contacts_terms": "Условия использования",
  "contacts_faq": "Частые вопросы",
  "faq_code_q": "Не приходит код из письма",
  "faq_code_a": "Проверьте «Спам» и правильность адреса. Кнопка «Отправить ещё раз» становится активной через минуту.",
  "faq_watch_q": "Часы не вибрируют",
  "faq_watch_a": "Разрешите уведомления Moonwake в настройках часов и проверьте, что таймер запущен на них.",
  "cab_today": "Сегодня: {0}",
  "cab_phases": "Фазы окна",
  "cab_edit_my_day": "Изменить во «Времени бодрствования»",
  "cab_note_today": "Заметка на сегодня",
  "cab_add_note": "+ Добавить заметку",
  "cab_no_notes": "Пока пусто. Первый смех, зубы, как спал — запишите, чтобы не забыть.",
  "cab_how_it_looks": "Как это выглядит",
  "cab_ring_note": "Кольцо на таймере и на часах повторяет ваш порядок и пропорции фаз.",
  "cab_rec_title": "Рекомендации для {0}",
  "cab_rec_text": "Окно {0}–{1} мин. Кормление и спокойная фаза не сокращаются, игру и уход можно сжимать, если задержались.",
  "cab_read_articles": "Читать статьи",
  "cab_week": "Окна за неделю",
  "cab_week_summary": "За неделю {0} · в среднем {1} в день",
  "cab_week_empty": "За неделю окон не было — нажмите «Проснулся», и здесь появятся столбики",
  "tour_step": "Как это работает · {0} из {1}",
  "tour_next": "Дальше",
  "tour_finish": "К таймеру",
  "tour_slides": "Шаги тура",
  "tour_slide_n": "Шаг {0}",
  "tour_title_1": "Нажали «Проснулся» — таймер запустился",
  "tour_text_1": "Кольцо показывает фазы окна: пройденные горят, будущие ждут. Внутри — сколько осталось в фазе и сколько всего бодрствует.",
  "tour_title_2": "Сигнал на каждой смене фазы",
  "tour_text_2": "Телефон и часы подскажут: пора кормить, играть, успокаивать. В конце — «Доброго сна». Забыли включить вовремя? Нажмите фазу, где вы сейчас, — расписание подстроится.",
  "tour_title_3": "Окна дня — под вашего малыша",
  "tour_text_3": "Расписание по возрасту даём мы, порядок и минуты — ваши. Окон может быть несколько: ВБ 1 после подъёма, ВБ 2 после первого сна… «+ ВБ» добавляет карточку, а рядом — сколько спать перед ней. Подсказку к фазе можно переписать своими словами, а какое ВБ идёт — выбрать кнопками над кольцом.",
  "tour_title_4": "Сон под присмотром",
  "tour_text_4": "После «уснул» кольцо считает сон и подсказывает, сколько спать по графику. Заворочался? «Продлить сон» даёт двадцать минут: удалось — сон идёт дальше, нет — окно начнётся с той минуты.",
  "signed_out": "Вы вышли из аккаунта. Данные на этом устройстве остались",
  "profile_language": "Язык",
  "profile_language_hint": "Экраны, уведомления и письма",
  "language_sheet_title": "Язык приложения",
  "profile_sound": "Звук сигнала",
  "group_settings": "Настройки",
  "profile_notifications_where": "Телефон, часы и браузер",
  "profile_sound_hint": "Короткий на смене, двойной на ритуале",
  "profile_tour_hint": "Пройти тур по приложению ещё раз",
  "profile_contacts_hint": "Ответим в течение дня",
  "profile_schedule_hint": "Меняется с возрастом малыша",
  "contacts_mail_hint": "Для длинных вопросов и вложений",
  "group_account": "Аккаунт",
  "group_help": "Помощь и контакты",
  "group_write": "Написать нам",
  "group_other_ways": "Другие способы",
  "group_docs": "Документы",
  "profile_notifications": "Уведомления о смене фазы",
  "unit_hours": "ч",
  "unit_kg": "кг",
  "unit_weeks": "нед",
  "unit_days": "дн.",
  "unit_months": "мес",
  "age_weeks_one": "{0} неделя",
  "age_weeks_few": "{0} недели",
  "age_weeks_many": "{0} недель",
  "age_months_one": "{0} месяц",
  "age_months_few": "{0} месяца",
  "age_months_many": "{0} месяцев",
  "reminder_wake_title": "Пора вставать",
  "reminder_wake_body": "{0} спит уже {1} — по возрасту пора вставать, иначе вечером будет тяжелее уснуть.",
  "reminder_evening_title": "Последнее бодрствование",
  "reminder_evening_body": "Пора будить: укладывание к {0}, это последнее окно на сегодня.",
  "reminder_weight_title": "{0} · вес",
  "reminder_weight_born_boy": "Родился {0} — сейчас обычно около {1}.",
  "reminder_weight_born_girl": "Родилась {0} — сейчас обычно около {1}.",
  "reminder_weight_usual": "Обычно в этом возрасте весят {0}.",
  "reminder_weight_first": "{0} — {1}. {2} Взвешивали? Запишите в календарь — покажем, как растёт.",
  "reminder_weight_again": "{0} — {1}. Последний вес {2}, {3} назад. {4} Взвесьте и запишите — сверим с коридором.",
  "error_network": "Не получилось связаться с сервером. Попробуйте ещё раз",
  "error_unknown": "Что-то пошло не так. Попробуйте ещё раз",
  "error_bad_email": "Проверьте адрес: кажется, в нём опечатка",
  "error_no_account": "В выбранной стране аккаунта с такой почтой нет. Проверьте страну; новый аккаунт заводится с экрана приветствия.",
  "error_code_wrong": "Код не подошёл. Проверьте цифры в письме",
  "error_code_expired": "Код устарел. Запросите новый",
  "error_code_used": "Этим кодом уже воспользовались. Запросите новый",
  "error_mail_failed": "Письмо не удалось отправить. Попробуйте позже",
  "error_email_taken": "Этот адрес уже занят другим аккаунтом",
  "error_same_email": "Это и есть текущий адрес",
  "error_too_soon": "Письмо уже отправлено. Подождите минуту",
  "error_too_soon_retry": "Письмо уже отправлено. Подождите минуту и попробуйте снова",
  "error_too_many": "Слишком много попыток. Попробуйте позже",
  "error_too_many_signin": "Слишком много попыток входа. Попробуйте через час",
  "error_too_many_attempts": "Слишком много попыток. Запросите новый код",
  "error_no_session": "Нужно войти в аккаунт",
  "code_clipboard_empty": "В буфере обмена нет шестизначного кода",
  "code_clipboard_denied": "Браузер не дал прочитать буфер обмена, введите код руками",
  "code_sent_text": "Отправили код на {0}. Введите шесть цифр или откройте ссылку из письма — тогда вход завершится сам.",
  "code_checking": "Проверяем…",
  "code_sign_in": "Войти",
  "code_paste": "Вставить код",
  "code_resend": "Отправить ещё раз",
  "code_resend_in": "Отправить ещё раз · {0}",
  "code_not_received": "Не пришло? Проверьте «Спам»",
  "code_or": "или",
  "code_change_email": "измените почту",
  "code_not_received_wait": "Не пришло? Проверьте папку «Спам» — письмо от hello@moonwake.online",
  "email_label": "Почта",
  "region_label": "Вы гражданин России или живёте в России?",
  "region_ru": "Да, Россия",
  "region_world": "Нет, другая страна",
  "region_hint_ru": "Данные будут храниться на сервере в России. Страну потом изменить нельзя.",
  "region_hint_world": "Данные будут храниться на сервере в Казахстане. Страну потом изменить нельзя.",
  "country_row_label": "Страна",
  "country_name_ru": "Россия",
  "country_name_other": "Казахстан",
  "country_change_q": "Сменить страну на «{0}»?",
  "country_change_note": "Данные переедут в «{0}». Вы останетесь в аккаунте, входить заново не нужно. Менять страну можно раз в 7 дней.",
  "country_xborder_kz": "Данные будут храниться в Казахстане. Согласен(на) на трансграничную передачу.",
  "country_change_send": "Отправить код",
  "country_change_code_sent": "Мы отправили код на вашу почту. Введите его, чтобы перенести данные.",
  "country_change_confirm": "Перенести",
  "country_change_done": "Данные перенесены: «{0}»",
  "country_change_too_soon": "Менять страну можно раз в 7 дней",
  "country_change_error": "Не удалось начать перенос. Попробуйте позже",
  "region_hint_tz": "Похоже, вы в России. Если это так, выберите «Да, Россия» — данные россиян хранятся в России.",
  "consent_terms": "Принимаю {0} и {1}.",
  "consent_terms_terms": "Условия использования",
  "consent_terms_privacy": "Политику конфиденциальности",
  "consent_child": "Я родитель или законный представитель ребёнка и даю согласие Кофман Михаилу Александровичу на обработку данных о нём — имени, даты рождения, пола, сна, веса и моих заметок — для расчёта расписания, уведомлений и синхронизации между устройствами. Понимаю, что отозвать согласие можно удалением аккаунта.",
  "consent_sign_note": "Отметка и ввод кода из письма — ваша простая электронная подпись под этим согласием.",
  "consent_required_error": "Чтобы создать аккаунт, нужно согласиться с условиями и подтвердить согласие на данные о ребёнке.",
  "consent_xborder_ru": "Письма о входе отправляются через наш сервер в Казахстане; адрес почты передаётся туда только для доставки. Согласен(на).",
  "consent_catchup_title": "Подтвердите согласие",
  "consent_catchup_note": "Сменился оператор персональных данных — теперь это Кофман Михаил Александрович. Чтобы продолжить пользоваться аккаунтом, подтвердите согласие заново.",
  "consent_save": "Подтверждаю",
  "signin_sending": "Отправляем…",
  "signin_title": "С возвращением",
  "signin_lead": "Введите почту — пришлём код для входа. Пароль не нужен.",
  "signin_check_mail": "Проверьте почту",
  "signed_in_as": "Вы вошли как {0}",
  "ready_tip_boy": "Как только {0} проснулся — нажмите кнопку. Уже в процессе? Нажмите на нужную фазу в списке ниже.",
  "ready_tip_girl": "Как только {0} проснулась — нажмите кнопку. Уже в процессе? Нажмите на нужную фазу в списке ниже.",
  "day_mode_earlier": "{0}: раньше",
  "day_mode_later": "{0}: позже",
  "weight_step_down": "−10 г",
  "weight_step_up": "+10 г",
  "ring_progress": "Пройдено {0}% окна",
  "nav_sections": "Разделы",
  "install_got_it": "Понятно",
  "splash_loading": "Загрузка",
  "minutes_one": "{0} минута",
  "minutes_few": "{0} минуты",
  "minutes_many": "{0} минут",
  "push_asleep_q": "Уснул?",
  "push_plan_over": "Ритуал по плану закончился. Ответьте в приложении — окно закроется по вашему ответу.",
  "push_next_sleep": "дальше сон",
  "push_next": "дальше {0}",
  "push_until": "до {0}",
  "mail_tagline": "Moonwake — ключ к хорошему сну",
  "mail_login_subject": "Код для входа в Moonwake: {0}",
  "mail_login_text": "Код для входа: {0}\n\nВведите его в приложении. Код действует {1}.\n\nИли откройте ссылку — вход завершится сам, вводить ничего не нужно:\n{2}\n\nЕсли вы не запрашивали вход, просто удалите это письмо: без кода и ссылки в аккаунт не попасть.\n\nMoonwake",
  "mail_login_html_preview": "Ваш код {0}. Действует {1}. Или войдите по ссылке из письма.",
  "mail_login_html_title": "Код для входа",
  "mail_login_html_lead": "Введите его в приложении или на сайте.",
  "mail_login_html_valid": "Код действует {0}.",
  "mail_login_html_or": "или",
  "mail_login_html_link": "Войти по ссылке",
  "mail_login_html_ignore": "Если вы не запрашивали вход — просто удалите это письмо. Без кода и ссылки в аккаунт не попасть.",
  "mail_migrated_subject": "Moonwake: данные перенесены",
  "mail_migrated_ru": "Данные вашего аккаунта Moonwake перенесены на сервер в России ({0}).\n\nЕсли страну вы не меняли — напишите на hello@moonwake.online.\n\nMoonwake",
  "mail_migrated_other": "Данные вашего аккаунта Moonwake перенесены на сервер в Казахстане ({0}).\n\nЕсли страну вы не меняли — напишите на hello@moonwake.online.\n\nMoonwake",
  "mail_delete_subject": "Код для удаления аккаунта Moonwake: {0}",
  "mail_delete_text": "Код для удаления аккаунта: {0}\n\nВведите его на странице удаления. Код действует {1}.\n\nУдаление необратимо: пропадут данные о малыше, окна бодрствования и заметки.\n\nЕсли вы этого не просили — просто удалите письмо, без кода ничего не произойдёт.\n\nMoonwake",
  "mail_email_code_subject": "Код для смены почты в Moonwake: {0}",
  "mail_email_code_text": "Код для смены почты: {0}\n\nВведите его в приложении. Код действует {1}.\n\nПосле подтверждения вход в аккаунт будет по этому адресу.\n\nЕсли вы этого не просили — просто удалите письмо.\n\nMoonwake",
  "mail_email_changed_subject": "Почта аккаунта Moonwake изменена",
  "mail_email_changed_text": "Почта аккаунта изменена на {0}.\n\nЕсли это сделали не вы — напишите нам на hello@moonwake.online, поможем вернуть доступ.\n\nMoonwake",
  "bot_open": "Открыть",
  "bot_yes_asleep": "Да, уснул ✓",
  "bot_next": "Дальше",
  "bot_asleep": "Уснул ✓",
  "entry_window": "Бодрствование",
  "window_from": "Проснулся",
  "window_to": "Уснул",
  "window_add_hint": "Укажите, когда малыш проснулся и когда уснул",
  "window_length": "Окно {0}",
  "window_bad_range": "Конец должен быть позже начала",
  "window_ahead": "Это время ещё не наступило",
  "window_overlap": "В это время уже записано окно {0}",
  "window_manual_mark": "вручную",
  "window_delete_q": "Удалить это окно?",
  "window_row_label": "Окно {0}, {1}",
  "window_tap_hint": "Ошиблись во времени? Нажмите на окно — время можно поправить или убрать его.",

  "window_edit_title": "Время окна",


  "sleep_edit_title": "Время сна",


  "sleep_length": "Сон {0}",


  "sleep_edit_hint": "Поправьте, когда малыш уснул и когда проснулся",


  "sleep_before_wake": "Уснул не может быть раньше пробуждения в {0}",


  "schedule_short": "ВБ",
  "schedule_fallback_notice": "Внесённые ВБ закончились — это окно по возрасту",
  "sleep_after_next": "Проснулся не может быть позже следующего засыпания в {0}",


  "sleep_too_long": "Сон длиннее {0} часов — проверьте время",


  "wake_note_hint": "Пара слов о том, как прошло бодрствование. Без подробностей о других людях — это личные данные.",

  "window_edit_hint": "Поправьте, когда малыш проснулся и когда уснул",

  "window_fixed_mark": "исправлено",

  "window_remove": "Убрать окно",

  "window_remove_q": "Убрать это окно?",

  "window_remove_text": "Окно исчезнет из календаря и аналитики на всех устройствах. Другие окна останутся.",

  "wake_tap_edit": "Нажмите на окно, чтобы поправить время или убрать его.",
  "window_entry_too_long": "Окно длиннее {0} часов — проверьте время"
}
